import React from "react";
import { useTranslation } from "react-i18next";
import chevronRight from "app/images/arrow-right.svg";
import { academySetupFaqItems } from "../../faq";
import styles from "./styles.module.scss";

const FaqList = () => {
  const { t } = useTranslation();

  return (
    <ul className={styles.list}>
      {academySetupFaqItems.map((item) => (
        <li key={item.titleKey} className={styles.row}>
          <a
            className={styles.link}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className={styles.title}>{t(item.titleKey)}</span>
            <img className={styles.chevron} src={chevronRight} alt="" />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default FaqList;
